"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _FilledOrdersComponent = _interopRequireDefault(require("./FilledOrdersComponent"));
var _futuresOrdersSelectors = require("../../../redux/futures/selectors/futuresOrdersSelectors");
var _futuresOrdersActions = require("../../../redux/futures/actions/futuresOrdersActions");
var _selectors = require("../../../redux/futures/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var selectedInstrument = _ref.selectedInstrument;
  return {
    data: (0, _futuresOrdersSelectors.futuresFilledOrdersSelector)(state),
    instruments: (0, _selectors.futuresInstrumentsSelector)(state),
    fetching: (0, _futuresOrdersSelectors.futuresFilledOrdersFetchingSelector)(state),
    selectedInstrument: selectedInstrument,
    selectedAccountId: (0, _get["default"])(state, 'user.selectedAccountId', 0),
    OMSId: (0, _get["default"])(state, 'user.userInfo.OMSId', 1),
    futuresAccount: true
  };
};
var mapDispatchToProps = {
  getAccountTrades: _futuresOrdersActions.getFuturesFilledOrders,
  resetActivePage: _futuresOrdersActions.resetFuturesActivePage
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FilledOrdersComponent["default"]);